import { SubscriptionTypes } from '../types/subscription.types';

type LicenseUsageSource = Pick<SubscriptionTypes.Model, 'users' | 'licensesConsumed' | 'licenseCount'>;

// Mirrors the POM Users `{ deletedAt: null }` match, which Mongo satisfies
// for a missing field or an explicit null.
const isDeleted = (user: { deletedAt?: Date | string | null }) =>
    user.deletedAt !== undefined && user.deletedAt !== null;

/**
 * Licenses in use, for display. `licensesConsumed` is a stored counter that
 * drifts from the real headcount, so count the non-deleted `users` the
 * customer-details payload already carries (the POM Users definition) and
 * fall back to the counter only when the payload has no users array.
 */
export const countLicensesConsumed = (subscription: LicenseUsageSource): number => {
    const { users } = subscription;
    if (Array.isArray(users)) {
        return users.filter((user) => !isDeleted(user)).length;
    }
    return subscription.licensesConsumed ?? 0;
};

/** Cap minus licenses in use. Negative when the subscription is over its cap. */
export const countLicensesAvailable = (subscription: LicenseUsageSource): number =>
    (subscription.licenseCount ?? 0) - countLicensesConsumed(subscription);
